import React, { Fragment, useCallback, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

import config, { API } from '../../config';

export default function MediaUploaderNewView() {
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const { SFMediaSubmissionID } = useParams();

  useEffect(() => {
    setLoading(true);
    const alreadyStatsUrl = `${API}/v1/upload/${SFMediaSubmissionID}/listFiles`;
    axios
      .get(alreadyStatsUrl)
      .then((d) => {
        console.log('[I] alreday stats api response', d);
        console.log('[I] alreday stats api response SFMediaSubmission');

        if (d.data && d.data.success) {
          setFiles(d.data.files);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log('[I] alreday stats api response ', err);
      });
  }, []);

  return (
    <div className="container">
      {loading ? (
        <div key="loader" className="loader">
          <img src="../../../pending.svg" alt="" />
        </div>
      ) : (
        ''
      )}

      <div key="files-list">
        <div className="media-uploader-files">
          <ul className="uploader-files-list">
            {files.map((f) => (
              <li key={f}>
                <div className="upload-files-meta">
                  <div className="uploader-file-name">
                    <span>{f}</span>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
